import styled, { css } from 'styled-components'
import { colors, IColoredTheme } from '../../styles'

interface IStyledFileZone extends IColoredTheme {
  small?: boolean
  disabled?: boolean
  htmlFor?: any // FIXME: remove in scope of #PTT-1209 @Andrew
}

export const StyledFileZone = styled.label<IStyledFileZone>`
  background-color: ${({ disabled, theme }) =>
    !disabled
      ? theme === 'blue'
        ? colors.fileUploadZoneBlue
        : colors.fileUploadZone
      : colors.grey10};
  cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'normal')};
  border-radius: 4px;
  text-align: center;
  height: 232px;
  width: 100%;
  max-width: 312px;
  ${({ small }) =>
    small &&
    css`
      height: 174px;
      width: 234px;
    `}

  display: flex;
  justify-content: center;
  align-items: center;

  & > section {
    color: ${({ disabled, theme }) =>
      !disabled
        ? theme === 'blue'
          ? colors.fileUploadZoneTextBlue
          : colors.fileUploadZoneText
        : colors.grey40};
    width: 165px;
    p {
      color: inherit;
      font-weight: 600;
    }
    svg {
      color: inherit;
      font-size: 40px;
    }
  }
  outline: none;
  position: relative;
  z-index: 101;
` as React.ComponentType<IStyledFileZone>
